<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle"></span>
        <h3 class="page-title">Laporan Donasi</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="card mb-4">
          <div class="card-body p-1 pb-3" style="overflow-x:scroll">
            <d-row style="margin:auto">
              <d-col md="6"  class="form-group" style="text-align:left;">
                <label for="feDate">From</label>
                <date-picker v-model.trim="fromdate"></date-picker>
             </d-col>
              <d-col md="6"  class="form-group" style="text-align:left;">
                <label for="feDate">To</label>
                <date-picker v-model.trim="todate"></date-picker>
             </d-col>
            </d-row>
            <br/><br/>
            <d-row style="margin:auto">
              <d-col md="6"  class="form-group">
                <label for="feGo">&nbsp;</label>
                <button type="button" class="btn-primary" @click="update_data"><i class="material-icons">send</i> Go</button>
                <label v-if="show_excel" for="feGo">&nbsp;</label>
                <button v-if="show_excel" type="button" class="btn-primary is-hidden-mobile" @click="xls"><i class="material-icons">border_all</i> Excel</button>
              </d-col>
            </d-row>
            <d-row>
            <d-col md="6"  class="form-group">
            </d-col>
            </d-row>
        <b-table
            id="dtable"
            :data="isEmpty ? [] : data"
            :loading="loading"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            >

            <template slot-scope="props">
                <b-table-column field="id" label="Id" >
                    <span class="tag is-success">
                    {{ props.row.id }}
                    </span>
                </b-table-column>
                <b-table-column field="fullname" label="Nama Lengkap" >
                    {{ props.row.fullname }}
                </b-table-column>
                <b-table-column field="created_at" label="Tgl buat" >
                    {{ props.row.created_at }}
                </b-table-column>
                <b-table-column field="transdate" label="Tgl transaksi" >
                    {{ props.row.transdate }}
                </b-table-column>
                <b-table-column field="amount" label="Nilai" style="text-align:right" >
                    {{ new Intl.NumberFormat().format(props.row.amount) }}
                </b-table-column>
                <b-table-column field="created_by" label="Dibuat oleh" >
                    {{ props.row.created_by }}
                </b-table-column>
                <b-table-column field="void" label="Status" >
                    {{ props.row.void==1? "Void":"" }}
                </b-table-column>
                <b-table-column field="created_by" label="Divoid oleh">
                    {{ props.row.voided_by }}
                </b-table-column>
            </template>
            <template slot="footer" >            
              <th></th>
              <th></th>
              <th></th>
              <th>Total : </th>
              <th style="text-align:right">{{ new Intl.NumberFormat().format(total_amount) }}</th>
              <th></th>
              <th></th>
              <th></th>
            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                icon="emoticon-sad"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>
{{ !loading && data.length==0 ? 'Tidak ada data' :'' }}
                        </p>
                    </div>
                </section>
            </template>
        </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import env from '../env.vue';
import DatePicker from "vuejs-datepicker";
import FileSaver from 'file-saver'

    export default {
        components: {
          DatePicker,
        },
        data() {
            return {
                fromdate:'',
                todate:'',
                sortField:'id',
                sortOrder:'asc',
                data:[],
                isEmpty: false,
                isHoverable: true,
                loading: false,
                hasMobileCards: false,
                sortIcon:'arrow-up',
                sortIconSize:'is-small',
                defaultSortOrder:'desc',
                search:'',
                show_excel:false,
                total_amount:'',
            }
        },
        watch:{
        },
        methods:{
          xls(){
    var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
    tab_text = tab_text + '<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';

    tab_text = tab_text + '<x:Name>List Donasi</x:Name>';
    tab_text = tab_text + '<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>';
    tab_text = tab_text + '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';
    tab_text = tab_text + "<table>";
    tab_text = tab_text + document.getElementById('dtable').childNodes[4].childNodes[0].innerHTML;
    tab_text = tab_text + '</table></body></html>';
    var file = new Blob([tab_text], {type: 'application/vnd.ms-excel;charset=utf-8;'});
    FileSaver.saveAs(file,'list_donasi.xls')
          },
          update_data(){
           let diff= Math.floor(new Date(this.todate)- new Date(this.fromdate))/(1000*60*60*24);
console.log('diff',diff);
           if (diff>366){
             alert('Tidak bisa lebih dari 1 tahun');
             return;
           }
           this.loading=true;
           this.axios.post( env.server+'/donation-list',{
             start: 0,
             length: 0,
             sort: this.sortField,
             sort_order: this.sortOrder,
             scfilter: this.fromdate,
             todate: this.todate,
           }).then(
             resp=>{
               resp.data=JSON.parse(resp.data);
               this.loading=false;
               this.data=resp.data.data.items;
               this.show_excel=true;
               this.total=resp.data.data.total_results;
               for (var i=0; i<this.data.length; i++ ){
                 this.data[i].idx=i;
                 let tmp=[];
                 tmp=this.data[i].transdate.split('-');
                 this.data[i].dob=tmp[2]+'-'+tmp[1]+'-'+tmp[0];
                 if ( this.data[i].void==0)
                   this.total_amount= this.total_amount*1 + this.data[i].amount*1;
               }
             }
           );
          },
        },
        mounted(){  
          var dt = new Date();
          this.fromdate=dt.getFullYear()+'-'+(dt.getMonth()+1)+'-'+dt.getDate();
          this.todate=dt.getFullYear()+'-'+(dt.getMonth()+1)+'-'+dt.getDate();
        },
    }
</script>
